import React from 'react';

import { useIntl } from 'react-intl';

import Button from '@atlaskit/button/new';
import { cssMap } from '@atlaskit/css';
import { Box, Flex } from '@atlaskit/primitives/compiled';

import { ClassificationView } from '../../common/ui/classification-view';
import { messages } from '../../messages';

import { type ReadPopupProps } from './types';

const styles = cssMap({
	container: {
		width: '330px',
	},
});

export const ReadPopup = ({
	name,
	guideline,
	guidelineADF,
	guidelineRepresentation = 'PLAIN',
	onChangeLevelClick,
	onChangeLevelMouseEnter,
}: ReadPopupProps): React.JSX.Element => {
	const intl = useIntl();

	return (
		<Box
			padding="space.250"
			xcss={styles.container}
			role="dialog"
			{...(name
				? { 'aria-labelledby': 'data-classification-read-content-name' }
				: { 'aria-label': intl.formatMessage(messages.dataClassificationLevelDialog) })} // accessibility fallback when name is not provided
			aria-describedby="data-classification-read-content-guideline"
			aria-modal="true"
		>
			<ClassificationView
				name={name}
				guideline={guideline}
				guidelineADF={guidelineADF}
				guidelineRepresentation={guidelineRepresentation}
			/>
			{Boolean(onChangeLevelClick) && (
				<Box paddingBlockStart="space.200">
					<Flex justifyContent="end" gap="space.100">
						<Button onClick={onChangeLevelClick} onMouseEnter={onChangeLevelMouseEnter}>
							{intl.formatMessage(messages.changeLevel)}
						</Button>
					</Flex>
				</Box>
			)}
		</Box>
	);
};
